export function validatePurchaseOrderNumber (pon) {
  return (!pon) || (pon.match('^[A-Za-z0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _-]*$') && pon.length <= 150)
}

export const uploadFile = function (file, loadCsv, errorReadingCsv) {
  const reader = new FileReader()
  reader.addEventListener('load', loadCsv)
  reader.addEventListener('error', errorReadingCsv)
  reader.readAsText(file)
}
